import gsap from 'imports/gsap'
import simpleSlideshowPrep from "site/simpleSlideshowPrep"
let popup = {
    init:function() {
        $('.reader').on('click touchstart', popup.open)
        $('#popup-close').on('click touchstart', popup.close)
        $(document).on('keyup', function(e) {
            if(e.which === 27){
                popup.close()
            }
        });
    },
    open:function( ) {
        let currentSlide = simpleSlideshowPrep.slidesTop.currentSlide
        if (currentSlide===0) {
            currentSlide=1
        }

        let sw = $(window).width()
        let mobileSize = 650
        if (sw < mobileSize) {
            //stupid page 3 thing
            currentSlide++
        }

        $('#popup .pages .page').hide()
        $('#popup .pages .page-'+currentSlide).show()

        if (sw >= mobileSize) {
            currentSlide++
            $('#popup .pages .page-' + currentSlide).show()
        }
        gsap.fromTo('#popup',
            {
                opacity:0,
            },
            {
                duration:0.75,
                opacity:1,
                ease:"Linear.easeNone",
            }
        )
        $('#popup').show()
    },
    close:function() {
        gsap.to('#popup',
            {
                duration:0.75,
                opacity:0,
                ease:"Linear.easeNone",
                onComplete:popup.close2
            }
        )
    },
    close2:function() {
        $('#popup').hide()
    }

}; //obj
export default popup
